import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ApprofondimentiRoutingModule } from './approfondimenti-routing.module';
import { ApprofondimentiComponent } from './approfondimenti.component';
import { ApprofondimentiPostComponent } from './approfondimenti-post/approfondimenti-post.component';

import {ScullyLibModule} from '@scullyio/ng-lib';

@NgModule({
  declarations: [
    ApprofondimentiComponent, 
    ApprofondimentiPostComponent
  ],
  imports: [
    CommonModule,
    ApprofondimentiRoutingModule,
    ScullyLibModule
  ]
})
export class ApprofondimentiModule { }
